<script>
import { mapState } from 'vuex';
import Loading from "@/components/Loading";
import PageHeader from "@/components/page-header";
import {updateProfile, resetTwoFactor, deleteUser} from "@/api/users";
import Swal from "sweetalert2";

export default {
  components: {PageHeader, Loading},
  data() {
    return {
      loading: false,
      title: "Profil Düzenle",
      items: [
        {
          text: "Profil Düzenle",
          active: true
        }
      ],
      form: {
        password: null,
      },
      sites: [],
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  methods: {
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          updateProfile(this.form).then(() => {
            this.$router.push('/');
          }).finally(() => {
            this.loading = false;
          })
        }
      });
    },
    handleResetTwoFactor() {
      Swal.fire({
        title: "Sıfırlamak istediğinizden emin misiniz?",
        text: "Bu işlemi geri alamazsınız!",
        icon: "error",
        showCancelButton: true,
        cancelButtonText: "Vazgeç",
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sıfırla"
      }).then((result) => {
        if(result.value){
          resetTwoFactor().then(() => {
            this.$bvToast.toast("İki adımlı doğrulama kaydınız sıfırlanmıştır.", {
              title: "Başarılı!",
              variant: 'success',
              solid: true
            })
          })
        }
      })
    },
  },
};

</script>
<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <Loading v-if="loading"/>
          <div class="card-body">
            <form @submit.prevent="submitForm">
              <div class="row">
                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="username" class="col-form-label">Kullanıcı Adı</label>
                    <input readonly id="username" name="username" v-model="user.username" type="text" class="form-control"/>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="email" class="col-form-label">E-Posta Adresi</label>
                    <input readonly id="email" name="email" v-model="user.email" type="text" class="form-control"/>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group mb-2">
                    <label for="password" class="col-form-label">Parola</label>
                    <input id="password" name="password" v-model="form.password" type="password" class="form-control"/>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end">
                <a @click="handleResetTwoFactor" class="btn btn-danger mr-2">İki Adımlı Doğrulama Sıfırlama</a>
                <button type="submit" class="btn btn-primary">{{'Profili Güncelle'}}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
